import * as PIXI from "pixi.js";
import { LoaderEvent } from "../../../loader/event/LoaderEvent";
import { Logger } from "../../../util/log/Logger";
import { TitanSpine } from "../../control/TitanSpine";
import { SpineConstants } from "../../control/constant/ControlConstants";
import { AbstractView } from "../AbstractView";
/**
 * Preloader.ts
 */
export class Preloader extends AbstractView {
    constructor(factory, properties, portraitProperties) {
        super(properties, portraitProperties);
        this.factory = factory;
        this.run();
    }
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.properties = properties;
    }
    create() {
        super.create();
        this.background = new PIXI.Graphics();
        this.addChild(this.background);
        this.renderer.setBackgroundColour(this.properties.backgroundColour);
        this.spine = TitanSpine.createSpine(this, this.properties.spineProperties, undefined, this.handleSpineComplete, this);
        this.playSpine();
        Logger.addObjectRef(this, "Preloader");
    }
    playSpine() {
        if (this.spine.getSpine().spineData.findAnimation(SpineConstants.ANIMATION)) {
            this.spine.play(SpineConstants.ANIMATION);
        }
        else {
            Logger.debug("Preloader: Missing spine animation: " + SpineConstants.ANIMATION);
            this.handleSpineComplete();
        }
    }
    handleSpineComplete() {
        let delay = this.message ? 3000 : 1000;
        this.callAfter(delay, this.handleComplete);
    }
    handleComplete() {
        console.log("PreLoader Complete");
        this.dispatchCore(LoaderEvent.PRELOADER_COMPLETE);
    }
    handleRotate(event) {
        super.handleRotate(event);
        this.properties = this.uiProperties;
        this.spine.position.copyFrom(this.properties.spineProperties.position);
    }
}
//# sourceMappingURL=Preloader.js.map